@if(authorizedEntityDetailsService.authorizedEntity()){
<pui-card title="Szczegóły" class="entity-details">
  <button card-action pui-button variant="secondary" (click)="authorizedEntityDetailsService.close()">
    <pui-icon left icon="x-close" />
  </button>
  <!-- HEADER -->
  <div class="entity-details__header">
    <div class="entity-details__title d-flex flex-column">
      <h2>{{authorizedEntity()?.name}}</h2>
      <div class="subtitle d-flex"><pui-badge
          [variant]="authorizedEntity()?.groupValue | groupColor">{{authorizedEntity()?.groupValue}}</pui-badge>
      </div>
    </div>
  </div>

  <!-- ACTIONS -->
  <div class="entity-details__actions">
    <button pui-button variant="primary" (click)="onAddPerson(authorizedEntity()?.uuid)">Dodaj osobę uprawnioną</button>
    <button pui-button variant="secondary" (click)="onEdit(authorizedEntity()?.uuid)">Edytuj dane</button>
    <button pui-button [puiMenuTriggerFor]="menu" variant="secondary">...</button>
    <ng-template #menu>
      <pui-menu-content>
        <button pui-button variant="secondary" pui-menu-item class="remove-button" (click)="onDelete()">Usuń
          podmiot</button>
      </pui-menu-content>
    </ng-template>
  </div>

  <!-- SECTION -->
  <div class="entity-details__section">
    <h3>Ogólne</h3>

    <div class="info-row">
      <span class="label">Nazwa</span>
      <span class="value">{{authorizedEntity()?.name}}</span>
    </div>

    <div class="info-row">
      <span class="label">Członkowie</span>
      <span class="value">{{authorizedEntity()?.authorizedPeople?.length ?? 0}}</span>
    </div>
  </div>

  <!-- SECTION -->
  <div class="entity-details__section">
    <h3>Dane kontaktowe</h3>

    <div class="info-row">
      <span class="label">Email</span>
      <a class="value" [href]="'mailto:' + authorizedEntity()?.email
">
        {{ authorizedEntity()?.email }}
      </a>
    </div>

    <div class="info-row">
      <span class="label">Numer telefonu</span>
      <span class="value">
        @for(tel of authorizedEntity()?.phones; track $index){
        {{tel}}
        }
      </span>
    </div>

    <div class="info-row">
      <span class="label">Strona internetowa</span>
      <a class="value" [href]="'http://' + authorizedEntity()?.website">
        {{ authorizedEntity()?.website }}
      </a>
    </div>

    <div class="info-row">
      <span class="label">Ulica</span>
      <span class="value">{{authorizedEntity()?.street}}</span>
    </div>

    <div class="info-row">
      <span class="label">Miasto</span>
      <span class="value">{{authorizedEntity()?.city}}</span>
    </div>
  </div>

  <!-- SECTION -->
  <div class="entity-details__section">
    <h3>Informacje dodatkowe</h3>
    <p>{{authorizedEntity()?.note}}</p>
  </div>
</pui-card>
}